import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAuthorityList,
  getCategoryList,
  postSubmitAmenities,
} from "../../services/apiEndPoints";

export const getCategoryListThunk = createAsyncThunk(
  "access/getCategoryList",
  async (application_categroy_id: number) => {
    try {
      const response = await getCategoryList(application_categroy_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const getAuthorityListThunk = createAsyncThunk(
  "access/getAuthorityList",
  async () => {
    try {
      const response = await getAuthorityList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const submitAmenitiesThunk = createAsyncThunk(
  "access/submitAmenities",
  async (payload: any) => {
    try {
      const response = await postSubmitAmenities(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  }
);
